export default function FlyIcon() {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.623397 8.37837C0.613691 8.14503 0.749175 7.92997 0.963831 7.83797L3.96383 6.55226C4.24937 6.42988 4.58005 6.56215 4.70243 6.84769C4.8248 7.13324 4.69253 7.46392 4.40699 7.58629L2.76685 8.28921L7.72725 9.94267C7.89522 9.99866 8.02702 10.1305 8.08301 10.2984L9.73647 15.2588L14.9637 3.062L7.40699 6.30058C7.12145 6.42295 6.79077 6.29068 6.66839 6.00514C6.54602 5.7196 6.67829 5.38892 6.96383 5.26654L15.8131 1.47401C16.0245 1.3834 16.2698 1.43064 16.4324 1.59328C16.595 1.75592 16.6423 2.0012 16.5517 2.21261L10.1877 17.0618C10.0957 17.2765 9.88065 17.412 9.64731 17.4023C9.41398 17.3926 9.21091 17.2397 9.13706 17.0181L7.10468 10.921L1.00753 8.88862C0.785978 8.81477 0.633102 8.6117 0.623397 8.37837Z"
          fill="#5E718D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.15165 10.8738C6.93198 10.6542 6.93198 10.298 7.15165 10.0783L15.3718 1.85821C15.5914 1.63854 15.9476 1.63854 16.1673 1.85821C16.3869 2.07788 16.3869 2.43404 16.1673 2.65371L7.94715 10.8738C7.72748 11.0935 7.37132 11.0935 7.15165 10.8738Z"
          fill="#5E718D"
        />
      </svg>
    </>
  );
}
